import { NotificationTransport } from "@modules/graphql/types"
import * as React from "react"
import { FaSlack } from "react-icons/fa"
import { MdComment, MdWeb } from "react-icons/md"

export type NotificationDeploysIconProps = {
  type: string
}
export function NotificationDeploysIcon({
  type,
  ...props
}: NotificationDeploysIconProps) {
  switch (type) {
    case NotificationTransport.OutgoingWebhook:
      return <MdWeb {...props} />

    case NotificationTransport.SlackWebhook:
      return <FaSlack {...props} />

    case NotificationTransport.PullRequestComment:
      return <MdComment {...props} />

    default:
      return null
  }
}
